import type { FeaturedTrace } from '@entangled-vega/shared';

import type { GraphIndex } from '../lib/graph.js';

type FeaturedDiscoveriesProps = {
  traces: readonly FeaturedTrace[];
  index: GraphIndex;
  onChoose: (source: string, target: string, storyId: string) => void;
};

const STORY_CARD_LIMIT = 6;

export function FeaturedDiscoveries({ traces, index, onChoose }: FeaturedDiscoveriesProps) {
  if (traces.length === 0) return null;
  return (
    <aside className="discovery-rail" aria-label="Connected stories to explore">
      <span>Start with a story</span>
      <div className="discovery-rail__stories">
        {traces.slice(0, STORY_CARD_LIMIT).map((trace) => {
          const source = index.peopleById.get(trace.source);
          const target = index.peopleById.get(trace.target);
          if (source === undefined || target === undefined) return null;
          return (
            <button
              type="button"
              key={trace.id}
              onClick={() => onChoose(trace.source, trace.target, trace.id)}
            >
              <strong>{source.name}</strong>
              <i aria-hidden="true">→</i>
              <strong>{target.name}</strong>
              <small>{trace.edgeIds.length} steps</small>
            </button>
          );
        })}
      </div>
      <div className="discovery-rail__links">
        <a href="/challenge/">Daily connection</a>
        <a href="/about#connections">Every connection has retained sources.</a>
      </div>
    </aside>
  );
}
